export default __webpack_public_path__ + "static/media/titiro-logo.6a965b40.svg";